import React, {Component} from 'react';
import './layout.scss';
import {NavLink} from "react-router-dom";
import footer from './../../assets/footer/footer.png';
import Header from "./../Header/header";
import Footer from "./../Footer/footer";
import $ from "jquery";


class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {};

    }

    componentWillMount() {

    }

    componentDidMount() {
        $('body,html').animate({
            scrollTop: 0
        })
    }

    componentWillUnmount() {

    }

    // shouldComponentUpdate() {
    //
    // }

    render() {
        return (
            <div className="layout-box">
                <Header location={this.props.location}></Header>
                {/*内容*/}
                <div className="content-box">
                    {this.props.children}
                </div>
                <Footer></Footer>
            </div>
        );
    }


}

export default Layout;


// WEBPACK FOOTER //
// ./src/pages/Index/index.js
